import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/fast_white.png';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const position = [41.17836945808101, -8.595839516727532];

let DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});
L.Marker.prototype.options.icon = DefaultIcon;

const socialLinks = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/fastfeup',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
        <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" fill="none"/>
        <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/feup-academic-solar-team/mycompany/',
    icon: (
      <svg width="24" height="24" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M45.11 0.14H4.21C2.25 0.14 0.67 1.69 0.67 3.6V44.67C0.67 46.58 2.25 48.14 4.21 48.14H45.11C47.07 48.14 48.67 46.58 48.67 44.68V3.6C48.67 1.69 47.07 0.14 45.11 0.14ZM14.91 41.04H7.78V18.13H14.91V41.04ZM11.34 15.01C9.06 15.01 7.21 13.16 7.21 10.88C7.21 8.61 9.06 6.76 11.34 6.76C13.62 6.76 15.47 8.61 15.47 10.88C15.47 13.15 13.62 15.01 11.34 15.01ZM41.57 41.04H34.45V29.91C34.45 27.25 34.41 23.83 30.75 23.83C27.05 23.83 26.49 26.73 26.49 29.72V41.04H19.38V18.13H26.2V21.26H26.3C27.24 19.46 29.57 17.56 33.03 17.56C40.24 17.56 41.57 22.3 41.57 28.47V41.04Z" fill="currentColor"/>
      </svg>
    ),
  }
];

const footerLinks = [
  { name: 'Home', path: '/' },
  { name: 'Atlântico', path: '/atlantico' },
  { name: 'Team', path: '/departments' },
  { name: 'Events', path: '/events' },
  { name: 'News', path: '/news' },
  { name: 'Sponsors', path: '/sponsors' },
];

function Footer() {
  return (
    <footer className="relative bg-slate-950 text-gray-400 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-mainBlue/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-mainBlue/5 rounded-full blur-3xl" />
      </div>
      <div className="h-px bg-gradient-to-r from-transparent via-mainBlue/40 to-transparent" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="flex flex-col gap-4">
            <Link to="/" className="w-32">
              <img src={logo} alt="FAST" />
            </Link>
            <p className="text-sm leading-relaxed">
              FEUP Academic Solar Team: Towards a Greener Blue.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-mainBlue transition-colors hover:scale-110"
                  aria-label={s.name}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-mainBlue transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Find Us</h4>
            <div className="rounded-xl overflow-hidden border border-white/10">
              <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: '180px', width: '100%' }}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={position}>
                  <Popup>
                    R. Dr. Roberto Frias<br />4200-465 Porto
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm">© FAST {new Date().getFullYear()}</p>
          <p className="text-xs text-gray-600">FEUP Academic Solar Team</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
